export const ApplicationDataKey = {
  NOTIFICATIONS_SEEN_AT: 'seen_notifications_at'
}

export const EMBEDDED_EVENT_REGEX = /nostr:(note1[a-z0-9]{58}|nevent1[a-z0-9]+|naddr1[a-z0-9]+)/g

export const DEFAULT_NOSTRCONNECT_RELAY = [
  'wss://relay.nsec.app/',
  'wss://bucket.coracle.social/',
  'wss://relay.primal.net/'
]

export const POLL_TYPE = {
  MULTIPLE_CHOICE: 'multiplechoice',
  SINGLE_CHOICE: 'singlechoice'
} as const

export const MAX_PINNED_NOTES = 3

export const PRIMARY_COLORS = {
  DEFAULT: {
    name: 'Default',
    light: {
      primary: '338 77% 53%',
      'primary-hover': '338 77% 62%',
      'primary-foreground': '0 0% 98%',
      ring: '338 77% 53%'
    },
    dark: {
      primary: '338 77% 53%',
      'primary-hover': '338 77% 62%',
      'primary-foreground': '0 0% 98%',
      ring: '338 77% 53%'
    }
  },
  RED: {
    name: 'Red',
    light: {
      primary: '0 65% 55%',
      'primary-hover': '0 65% 65%',
      'primary-foreground': '0 0% 98%',
      ring: '0 65% 55%'
    },
    dark: {
      primary: '0 65% 55%',
      'primary-hover': '0 65% 65%',
      'primary-foreground': '240 5.9% 10%',
      ring: '0 65% 55%'
    }
  },
  ORANGE: {
    name: 'Orange',
    light: {
      primary: '30 100% 50%',
      'primary-hover': '30 100% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '30 100% 50%'
    },
    dark: {
      primary: '30 100% 50%',
      'primary-hover': '30 100% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '30 100% 50%'
    }
  },
  AMBER: {
    name: 'Amber',
    light: {
      primary: '42 100% 50%',
      'primary-hover': '42 100% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '42 100% 50%'
    },
    dark: {
      primary: '42 100% 50%',
      'primary-hover': '42 100% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '42 100% 50%'
    }
  },
  YELLOW: {
    name: 'Yellow',
    light: {
      primary: '54 100% 50%',
      'primary-hover': '54 100% 60%',
      'primary-foreground': '0 0% 10%',
      ring: '54 100% 50%'
    },
    dark: {
      primary: '54 100% 50%',
      'primary-hover': '54 100% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '54 100% 50%'
    }
  },
  LIME: {
    name: 'Lime',
    light: {
      primary: '90 60% 50%',
      'primary-hover': '90 60% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '90 60% 50%'
    },
    dark: {
      primary: '90 60% 50%',
      'primary-hover': '90 60% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '90 60% 50%'
    }
  },
  GREEN: {
    name: 'Green',
    light: {
      primary: '140 60% 40%',
      'primary-hover': '140 60% 50%',
      'primary-foreground': '0 0% 98%',
      ring: '140 60% 40%'
    },
    dark: {
      primary: '140 60% 40%',
      'primary-hover': '140 60% 50%',
      'primary-foreground': '240 5.9% 10%',
      ring: '140 60% 40%'
    }
  },
  EMERALD: {
    name: 'Emerald',
    light: {
      primary: '160 70% 40%',
      'primary-hover': '160 70% 50%',
      'primary-foreground': '0 0% 98%',
      ring: '160 70% 40%'
    },
    dark: {
      primary: '160 70% 40%',
      'primary-hover': '160 70% 50%',
      'primary-foreground': '240 5.9% 10%',
      ring: '160 70% 40%'
    }
  },
  TEAL: {
    name: 'Teal',
    light: {
      primary: '180 70% 40%',
      'primary-hover': '180 70% 50%',
      'primary-foreground': '0 0% 98%',
      ring: '180 70% 40%'
    },
    dark: {
      primary: '180 70% 40%',
      'primary-hover': '180 70% 50%',
      'primary-foreground': '240 5.9% 10%',
      ring: '180 70% 40%'
    }
  },
  CYAN: {
    name: 'Cyan',
    light: {
      primary: '200 70% 40%',
      'primary-hover': '200 70% 50%',
      'primary-foreground': '0 0% 98%',
      ring: '200 70% 40%'
    },
    dark: {
      primary: '200 70% 40%',
      'primary-hover': '200 70% 50%',
      'primary-foreground': '240 5.9% 10%',
      ring: '200 70% 40%'
    }
  },
  SKY: {
    name: 'Sky',
    light: {
      primary: '210 70% 50%',
      'primary-hover': '210 70% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '210 70% 50%'
    },
    dark: {
      primary: '210 70% 50%',
      'primary-hover': '210 70% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '210 70% 50%'
    }
  },
  BLUE: {
    name: 'Blue',
    light: {
      primary: '220 80% 50%',
      'primary-hover': '220 80% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '220 80% 50%'
    },
    dark: {
      primary: '220 80% 50%',
      'primary-hover': '220 80% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '220 80% 50%'
    }
  },
  INDIGO: {
    name: 'Indigo',
    light: {
      primary: '230 80% 50%',
      'primary-hover': '230 80% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '230 80% 50%'
    },
    dark: {
      primary: '230 80% 50%',
      'primary-hover': '230 80% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '230 80% 50%'
    }
  },
  VIOLET: {
    name: 'Violet',
    light: {
      primary: '250 80% 50%',
      'primary-hover': '250 80% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '250 80% 50%'
    },
    dark: {
      primary: '250 80% 50%',
      'primary-hover': '250 80% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '250 80% 50%'
    }
  },
  PURPLE: {
    name: 'Purple',
    light: {
      primary: '280 80% 50%',
      'primary-hover': '280 80% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '280 80% 50%'
    },
    dark: {
      primary: '280 80% 50%',
      'primary-hover': '280 80% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '280 80% 50%'
    }
  },
  FUCHSIA: {
    name: 'Fuchsia',
    light: {
      primary: '310 80% 50%',
      'primary-hover': '310 80% 60%',
      'primary-foreground': '0 0% 98%',
      ring: '310 80% 50%'
    },
    dark: {
      primary: '310 80% 50%',
      'primary-hover': '310 80% 60%',
      'primary-foreground': '240 5.9% 10%',
      ring: '310 80% 50%'
    }
  },
  PINK: {
    name: 'Pink',
    light: {
      primary: '330 80% 60%',
      'primary-hover': '330 80% 70%',
      'primary-foreground': '0 0% 10%',
      ring: '330 80% 60%'
    },
    dark: {
      primary: '330 80% 60%',
      'primary-hover': '330 80% 70%',
      'primary-foreground': '240 5.9% 10%',
      ring: '330 80% 60%'
    }
  },
  ROSE: {
    name: 'Rose',
    light: {
      primary: '350 80% 60%',
      'primary-hover': '350 80% 70%',
      'primary-foreground': '0 0% 10%',
      ring: '350 80% 60%'
    },
    dark: {
      primary: '350 80% 60%',
      'primary-hover': '350 80% 70%',
      'primary-foreground': '240 5.9% 10%',
      ring: '350 80% 60%'
    }
  }
} as const
export type TPrimaryColor = keyof typeof PRIMARY_COLORS

export const LONG_PRESS_THRESHOLD = 500
